import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-843" data-mp="16j60bub2a3rb">
      {/* Navigation */}
      <SiteHeader currentPath="/investors" data-id="element-844" data-mp="11mp7imsx317w" />

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-845" data-mp="wl9r581opivu">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-846" data-mp="rorl84umbehx"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-847" data-mp="2eyxmmvb3xqv6"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-848" data-mp="2sxnkid5r3ukl">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-849" data-mp="2svkkr1esqn2o">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-850" data-mp="2j0960j3e1fux">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-851" data-mp="17kasa1x9m5nd">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-852" data-mp="1ckyu7in186wd">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-853" data-mp="3f4rfz3xrezdr">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-854" data-mp="2vj4wiwuufey2" />
      <BusinessModel data-id="element-855" data-mp="2vjemikfw1m3r" />
      <TractionSection data-id="element-856" data-mp="2rghxobzr8trd" />
      <GrowthRoadmap data-id="element-857" data-mp="2rfyq9p7qdnrl" />
      <VisionSection data-id="element-858" data-mp="2rfoypx71f8js" />
      <LeadershipSection data-id="element-859" data-mp="2rf6v2fi1ps1u" />
      <FundraiseSection data-id="element-860" data-mp="2mhdpnookh22m" />

      <SiteFooter currentPath="/investors" data-id="element-861" data-mp="2mglswaj8gyar" />
    </main>;
}